import ProfilePicture from "@/components/common/profile-picture";
import { formatImageUrl } from "@/lib/utils";
import { ArrowUpRightIcon } from "lucide-react";
import Link from "next/link";
import React from "react";

const ambassadorPlaceholders = [
	{
		id: "LOpXV4",
		image: "/images/person-2.jpg",
		name: "Harry Sky",
		role: "Tinolex, CEO",
		isVerified: true,
		isFounder: true,
	},
	{
		id: "ks2tkz",
		image: "/images/person-1.jpg",
		name: "Pooja Thakre",
		role: "Tinolex, CEO",
		isVerified: true,
		isFounder: true,
	},
];

type TListingAmbassadors = {
	ambassadors: {
		image: string | null;
		name: string | null;
		id: string;
		UserProfile: {
			isVerified: boolean | null;
			username: string;
			jobTitle: string | null;
			company: string | null;
			isFounder: boolean | null;
		} | null;
	}[];
};

const ListingAmbassadors = ({ ambassadors }: TListingAmbassadors) => {
	return (
		<div className="w-full p-6 bg-white shadow-xl rounded-xl bg-gradient-to-b from-brand-primary/5 to-brand-primary/25 shadow-black/10">
			<div className="flex items-center w-full gap-1">
				<span className="text-lg font-medium tracking-widest text-gray-500 uppercase md:text-xl">
					Ambassadors
				</span>

				<ArrowUpRightIcon className="w-6 h-6 text-gray-500" />
			</div>

			<div className="flex flex-col gap-6 mt-4">
				{ambassadors?.length > 0
					? ambassadors.map((ambassador) => (
							<div key={ambassador.id} className="flex gap-4">
								<Link href={`/${ambassador.UserProfile?.username}`}>
									<ProfilePicture
										profilePictureUrl={formatImageUrl(ambassador.image)}
										alternateText={ambassador.name}
										isAmbassador={true}
										isVerified={ambassador.UserProfile?.isVerified}
										isFounder={ambassador.UserProfile?.isFounder}
										className={{
											container: "h-12 w-12 rounded-full lg:h-16 lg:w-16",
											image: "h-10 w-10 rounded-full lg:h-14 lg:w-14",
											badgeImage: "w-12",
										}}
									/>
								</Link>

								<div className="flex flex-col justify-center gap-1">
									<Link href={`/${ambassador.UserProfile?.username}`}>
										<span className="text-lg font-semibold">{ambassador.name}</span>
									</Link>

									<span className="text-sm text-gray-600">
										{ambassador.UserProfile?.jobTitle} | {ambassador.UserProfile?.company}
									</span>
								</div>
							</div>
					  ))
					: ambassadorPlaceholders.map((ambassador) => (
							<div key={ambassador.id} className="flex gap-4">
								<ProfilePicture
									profilePictureUrl={ambassador.image}
									alternateText={ambassador.name}
									isAmbassador={true}
									isVerified={ambassador.isVerified}
									isFounder={ambassador.isFounder}
									className={{
										container: "h-12 w-12 rounded-full lg:h-16 lg:w-16",
										image: "h-full w-full rounded-full",
										badgeImage: "w-12",
									}}
								/>
								<div className="flex flex-col justify-center gap-2">
									<span className="text-lg font-semibold">{ambassador.name}</span>
									<span className="text-gray-600">{ambassador.role}</span>
								</div>
							</div>
					  ))}
			</div>
		</div>
	);
};

export default ListingAmbassadors;
